const WEEKDAYS = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
const MONTHS_SHORT = ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июня', 'июля', 'авг.', 'сен.', 'окт.', 'нояб.', 'дек.'];

export const formatDate = (
  date: Date,
  shouldPrintYear: boolean = false,
  shouldPrintMonth: boolean = false,
  shouldPrintWeekday: boolean = false,
): string => {
  const shortYear = date.getFullYear().toString().substring(2);
  const year = shouldPrintYear ? shortYear : null;

  const weekdayNumber = date.getDay();
  const weekday = shouldPrintWeekday ? `${WEEKDAYS[weekdayNumber]},` : null;

  const dayOfMonth = date.getDate();

  const monthNumber = date.getMonth();
  const month = shouldPrintMonth ? MONTHS_SHORT[monthNumber] : null;

  return [weekday, dayOfMonth, month, year].filter(Boolean).join(' ');
};
